import React, { Component } from 'react';

class AdministradoraItem extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(event) {
        if(!this.props.esEdicion){
            this.props.getDataByAdministratorId(this.props.id, this.props.abreviatura)
        }
    }

    componentDidMount() {
        if (this.props.checked) {
            this.props.getDataByAdministratorId(this.props.id, this.props.abreviatura);
        }
    }
    
    render() {    
        return (
            <div className={this.props.clase}>
                <div className="col-xs-3">
                    <input
                        id={"rbAdministrator" + this.props.id}
                        value={this.props.id}
                        type="radio"
                        name="rbAdministrator"
                        checked={this.props.checked}
                        onChange={(event) => this.onChange(event)} />
                    <label
                        className="lbl-radio label-secondary"
                        htmlFor={"rbAdministrator" + this.props.id}>
                        {this.props.descripcion}
                    </label>
                </div>
            </div>
        );
    }
};

export default AdministradoraItem;